var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { BuildingFloor } from '../../../models/index';
import { MapPlanBase } from './map-plan-base.model';
import { LocaleService } from '../../../seo/locale.service';
import { ListTrackingService } from './../../../utils/list-tracking.service';
var MapPlanBuildingFloorBaseComponent = /** @class */ (function (_super) {
    __extends(MapPlanBuildingFloorBaseComponent, _super);
    function MapPlanBuildingFloorBaseComponent(localeService, zone, document, window, listTrackingService) {
        var _this = _super.call(this, zone, window) || this;
        _this.localeService = localeService;
        _this.zone = zone;
        _this.document = document;
        _this.window = window;
        _this.listTrackingService = listTrackingService;
        return _this;
    }
    MapPlanBuildingFloorBaseComponent.prototype.ngAfterViewInit = function () {
        this.runImgMappingScript();
    };
    MapPlanBuildingFloorBaseComponent.prototype.ngOnDestroy = function () {
        this.removeImgMappingScript();
    };
    MapPlanBuildingFloorBaseComponent.prototype.currentRoute = function () {
        return this.document.location.href;
    };
    MapPlanBuildingFloorBaseComponent.prototype.propertyToolTip = function (property) {
        if (this.propertyToolTipText)
            return this.propertyToolTipText(property);
        return property.title + ' [ap: ' + property.number + ']<br>(' + this.propertyAvailability(property.availability) + ')';
    };
    MapPlanBuildingFloorBaseComponent.prototype.propertyAvailability = function (availability) {
        var translated = {};
        if (this.localeService.getCurrentLocale() === 'ro') {
            translated = {
                available: 'Disponibil',
                sold: 'Vândut',
                unavailable: 'Indisponibil',
                reserved: 'Rezervat'
            };
        }
        else if (this.localeService.getCurrentLocale() === 'en') {
            translated = {
                available: 'Available',
                sold: 'Sold',
                unavailable: 'Unavailable',
                reserved: 'Reserved'
            };
        }
        else {
            return availability;
        }
        return translated[availability];
    };
    return MapPlanBuildingFloorBaseComponent;
}(MapPlanBase));
export { MapPlanBuildingFloorBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-building-floor-base.component.ts.pre-build-optimizer.js